import { inject } from "@angular/core";
import {
  ActivatedRouteSnapshot,
  ResolveFn,
  RouterStateSnapshot,
} from "@angular/router";
import { Store } from "@ngrx/store";
import { FunnelHeaderMilestone, FunnelHeaderStepType } from "pax-ui/components";
import { filter, map } from "rxjs";
import { allFunnelHeaderMilestones } from "src/app/shared/routes/global-route.constant";
import { QueryStringParameterKey } from "src/app/shared/routes/shared/shared-route.constant";
import { AppState } from "src/app/shared/store/app.state";
import { selectFeatureState } from "src/app/shared/store/quote/term-life-insurance/quote.selectors";

export const funnelHeaderMilestonesResolver: ResolveFn<
  FunnelHeaderMilestone[]
> = (
  activatedRouteSnapshot: ActivatedRouteSnapshot,
  _: RouterStateSnapshot,
) => {
  const store = inject(Store<AppState>);

  const quoteId = activatedRouteSnapshot.queryParamMap.get(
    QueryStringParameterKey.QUOTE_ID,
  );

  if (quoteId) {
    // makes a deep copy of the original array because we need that original array to handle routing in our skipping guard
    const filteredFunnelHeaderMilestones: FunnelHeaderMilestone[] =
      structuredClone(allFunnelHeaderMilestones);

    return store.select(selectFeatureState).pipe(
      filter((featureState) => !featureState.isBusy),
      map((featureState) => {
        if (featureState.isLegacyApplication) {
          filteredFunnelHeaderMilestones.forEach((milestone, index) => {
            const filteredSteps = milestone.steps.filter(
              (step) => step.type !== FunnelHeaderStepType.DIGITAL_APPLICATION,
            );
            // should remove the milestone, if all steps within were removed
            if (filteredSteps.length === 0) {
              filteredFunnelHeaderMilestones.splice(index, 1);
            } else {
              milestone.steps = filteredSteps;
            }
          });

          return filteredFunnelHeaderMilestones;
        }
        return allFunnelHeaderMilestones;
      }),
    );
  }
  return allFunnelHeaderMilestones;
};
